class CallMethodOnElem {
    constructor (theme, elem) {
        this._elem = elem
        this._data = JSON.parse(elem.getAttribute('data-call-method-on-elem'))
    }

    onInit () {
        if (this._data.length) {
            for (let data of this._data) {
                this._eventLogic(data)
            }
        } else {
            this._eventLogic(this._data)
        }
    }

    _eventLogic (data) {
        let targetElems = document.querySelectorAll(data.target)
        for (let targetElem of targetElems) {
            this._elem.addEventListener(data.on, (e) => {
                if (data.preventDefault) {
                    e.preventDefault()
                }
                targetElem[data.method]()
            })
        }
    }
}

export default CallMethodOnElem



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CallMethodOnElem.js